import type { UI } from '@/v2/types';
import { Flex } from '@qga/roo-ui/components';

import { CtaEvent } from '@shared/v2/components/createRoomOptionCTA/types';

import { useCustomerSelection } from '@/components/CustomerSelectionProvider';
import { OnCtaClickOpts } from '@/v2/components/pages/PackageView/components/RoomOptions/hooks/useCtaOnClick/useCtaOnClick';
import Divider from '@/v2/components/ui/Divider';
import {
  BookingConditions,
  CTA,
  Description,
  DetailsButton,
  EarnPoints,
  MaxOccupants,
  Name,
  Pictures,
  SelectableCard,
} from './components';

export type RoomOptionProps = {
  roomOption: UI.RoomOption;
  isSelected: boolean;
  onCtaClick: (event: CtaEvent, opts: OnCtaClickOpts) => void;
  roomIndex: number;
  isMainRooms?: boolean;
};

const RoomOption = ({
  roomOption,
  isSelected,
  onCtaClick,
  roomIndex,
  isMainRooms,
}: RoomOptionProps) => {
  const { roomType } = roomOption;
  const { images, mainImage, name, maxOccupants, description } = roomType || {};
  const { usePoints, usePointsPlusPay } = useCustomerSelection();

  return (
    <Flex flexDirection="column" gap="3">
      <SelectableCard data-testid="ROOM_OPTION" isSelected={isSelected}>
        <Pictures
          images={images}
          mainImage={mainImage}
          roomName={roomType.name}
        />
        <Flex flex="1 1 auto" flexDirection="column" alignItems="flex-start">
          <Name name={name} />
          <MaxOccupants maxOccupants={maxOccupants} />
          <Description description={description} />
          <DetailsButton roomType={roomType} />
          {!usePoints && !usePointsPlusPay && (
            <>
              <Divider my="4" width="100%" />
              <EarnPoints />
            </>
          )}
          <CTA
            onClick={(event, opts) =>
              onCtaClick(event, { ...opts, roomOption, roomIndex })
            }
            isSelected={isSelected}
            roomOption={roomOption}
            isMainRooms={isMainRooms}
          />
        </Flex>
      </SelectableCard>
      <BookingConditions />
    </Flex>
  );
};

export default RoomOption;
